import './select.css';

import { Portal } from '@radix-ui/react-portal';
import { Content, Viewport } from '@radix-ui/react-select';
import React from 'react';

import { cn } from '@/services/utils';

/**
 * The component that pops out when the select is open.
 */
const SelectContent = React.forwardRef<
    React.ElementRef<typeof Content>,
    React.ComponentPropsWithoutRef<typeof Content>
>(({ className, children, position = 'popper', ...props }, ref) => (
    <Portal>
        <Content
            ref={ref}
            className={cn(
                `select-content
                tw-relative
                tw-z-[9999]
                tw-min-w-[8rem]
                tw-overflow-hidden
                tw-rounded-md
                tw-border
                tw-bg-white
                tw-text-popover-foreground
                tw-shadow-md
                tw-animate-in
                tw-fade-in-80`,
                position === 'popper' && 'tw-translate-y-1',
                className,
            )}
            position={position}
            {...props}
        >
            <Viewport
                className={cn(
                    'tw-p-1',
                    position === 'popper' &&
                    `tw-h-[var(--radix-select-trigger-height)]
                        tw-w-full
                        tw-min-w-[var(--radix-select-trigger-width)]`,
                )}
            >
                {children}
            </Viewport>
        </Content>
    </Portal>
));

SelectContent.displayName = Content.displayName;

export { SelectContent };
